import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import _ from 'underscore';

import questionActions from '../../actions/questions';
import ResponsesManager from '../questions/responsesManager'
import { FocusPointsInputAndConceptSelectorForm, } from '../../../Shared/index';

class NewFocusPointsContainer extends Component {
  getFocusPoints = () => {
    const { match, questions, } = this.props;
    const { params } = match;
    const { questionID } = params;
    return questions.data[questionID].focusPoints;
  }

  submitFocusPointForm = data => {
    const { match, dispatch, history } = this.props;
    const { params } = match;
    const { questionID } = params;
    if (data.conceptResults && data.conceptResults.null !== undefined) {
      delete data.conceptResults.null;
    }
    data.order = _.keys(this.getFocusPoints()).length + 1;
    dispatch(questionActions.submitNewFocusPoint(questionID, data, () => {
      history.push(`/admin/questions/${questionID}/focus-points`);
    }));
  };

  render() {
    const { children, fillInBlank, match, questions } = this.props;
    const { params } = match;
    const { questionID } = params;
    return (
      <div>
        <FocusPointsInputAndConceptSelectorForm
          fillInBlank={fillInBlank}
          itemLabel="Focus Point"
          onSubmit={this.submitFocusPointForm}
          questionID={questionID}
          questions={questions}
          ResponsesManager={ResponsesManager}
          states={true}
        />
        {children}
      </div>
    );
  }
}

function select(props) {
  return {
    questions: props.questions,
    fillInBlank: props.fillInBlank
  }
}

export default withRouter(connect(select)(NewFocusPointsContainer));
